import { isArray } from '@mescius/wijmo';
import { Palettes } from '@mescius/wijmo.chart';
import * as wijmo from '@mescius/wijmo';

export function getData(data) {
    // created sorted view

    let view = new wijmo.CollectionView(data);
    // view.sortDescriptions.push(new wijmo.SortDescription('y', true));
    //
    _updateCumSales(view);
    //
    // update cumulative sales when the data changes
    view.collectionChanged.addHandler(() => _updateCumSales(view));
    // view.refresh(); 
    //
    // done
    return view;
}
function getPalette() {
    // Get random palette
    let palettes = Object.keys(Palettes).filter(prop => isArray(Palettes[prop]));
    let rand = Math.floor(Math.random() * palettes.length);
    //
    return Palettes[palettes[rand]];
}
function _updateCumSales(view) {
    let totalSales = view.getAggregate(wijmo.Aggregate.Sum, 'y'), cummulative = 0;
    //
    view.items.forEach((item) => {
        cummulative += Number(item.y) || 0;
        item.cummulative = cummulative / (totalSales || 1);
    });
}
// export const data = getData();
export const palette = getPalette();
